module.exports = __webpack_public_path__ + "static/media/5.87254569.jpg";